import React, { useMemo } from 'react';
import { Box, FormControlLabel, Switch } from '@material-ui/core';
import ColumnFilterPanel from '@/components/CustomizableTable/ColumnFilterPanel';
import { css } from '@emotion/react';
import { colors } from '@/styles';

const AdminSettingsPanel = ({ open, onClose, marketplace, setMarketplace, test, setTest, disabled = false }) => {
    const controls = useMemo(
        () => (
            <Box
                css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    padding: 1rem;
                `}
            >
                <FormControlLabel
                    label={marketplace ? 'Marketplace' : 'OMS'}
                    disabled={disabled}
                    control={
                        <Switch
                            checked={!!marketplace}
                            onChange={() => setMarketplace?.((prev) => !prev)}
                            color="primary"
                        />
                    }
                    css={css`
                        .Mui-checked {
                            color: ${colors.greens.primary};
                        }
                        .Mui-checked + .MuiSwitch-track {
                            background-color: ${colors.greens.primary};
                        }
                    `}
                />
                <FormControlLabel
                    label="Test Accounts"
                    disabled={disabled}
                    control={<Switch checked={!!test} onChange={() => setTest?.((prev) => !prev)} color="primary" />}
                    css={css`
                        .Mui-checked {
                            color: ${colors.greens.primary};
                        }
                        .Mui-checked + .MuiSwitch-track {
                            background-color: ${colors.greens.primary};
                        }
                    `}
                />
            </Box>
        ),
        [disabled, marketplace, setMarketplace, test, setTest]
    );

    return (
        <ColumnFilterPanel
            open={open}
            columnId="admin_settings"
            title="Admin Settings"
            onClose={onClose}
            topOffset={50}
            showClearButton={false}
            showApplyButton={false}
        >
            {controls}
        </ColumnFilterPanel>
    );
};

export default AdminSettingsPanel;
